// import api's and mutations
import {
  CAO,
  CAOType,
  deleteCAO,
  getCAO,
  saveCAO
} from 'RestAPIs/contacts/cao';

// import components
import Button from '@sdb/ui/atoms/Button';
import Chip from '@sdb/ui/atoms/Chip';
import { Box, ButtonGroup, Popover } from '@mui/material';
import { showSnackbar } from 'components/shared';

// import hooks
import { MouseEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const caoList = [
  {
    type: 'APOTHEKEN'
  },
  {
    type: 'GEESTELIJKE_GEZONDHEIDSZORG'
  },
  {
    type: 'GEHANDICAPTENZORG'
  },
  {
    type: 'HUISARTSENZORG'
  },
  {
    type: 'JEUGDZORG'
  },
  {
    type: 'KINDEROPVANG'
  },
  {
    type: 'VERZORGING_VERPLEGING_THUISZORG'
  },
  {
    type: 'SOCIAAL_WERK'
  },
  {
    type: 'ZIEKENHUIZEN'
  },
  {
    type: 'OVERIG'
  }
];

const CaoSection = () => {
  const { t } = useTranslation('common');
  const [activeCaos, setActiveCaos] = useState<CAO[]>([]);

  const getActiveCaos = async () => {
    const { data } = await getCAO();
    setActiveCaos(data);
  };

  useEffect(() => {
    getActiveCaos();
  }, []);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'cao-popover' : undefined;

  const onSave = async (type: CAOType) => {
    try {
      await saveCAO({ type });
      await getActiveCaos();
      handleClose();
      showSnackbar({ severity: 'success', message: t('changesSaved') });
    } catch {
      handleClose();
      showSnackbar({
        severity: 'error',
        message: t('somethingWentWrong')
      });
    }
  };

  const onDelete = async (claId: number) => {
    try {
      await deleteCAO(claId);
      await getActiveCaos();
      showSnackbar({ severity: 'success', message: t('changesSaved') });
    } catch {
      showSnackbar({
        severity: 'error',
        message: t('somethingWentWrong')
      });
    }
  };

  return (
    <>
      <Box display="flex" mb={4}>
        <Box display="flex" width="100%">
          <Box width="90%" display="flex" flexWrap="wrap" gap={2}>
            {activeCaos.map(({ type, id }) => {
              return (
                <Chip
                  key={type}
                  label={t(`CAO.${type}`)}
                  onDelete={() => onDelete(id)}
                />
              );
            })}
          </Box>
          <Box ml="auto">
            <Button
              variant="contained"
              onClick={handleClick}
              sx={{ width: 'max-content' }}
            >
              {t('addCAO')}
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
            >
              <ButtonGroup orientation="vertical">
                {caoList.map(({ type }) => {
                  return (
                    <Button
                      key={type}
                      onClick={() => onSave(type as CAOType)}
                      disabled={activeCaos.some((ac) => ac.type === type)}
                    >
                      {t(`CAO.${type}`)}
                    </Button>
                  );
                })}
              </ButtonGroup>
            </Popover>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CaoSection;
